export const mcApi = {
    authentication: {
        auth: 'api/auth',
        users: 'api/users',
        addUser: 'api/user/AddUser'
    },

    testServer: {
        wait: 'api/health/{wait}/wait',
        test: 'api/health/test'
    },

    lab: {
        labs: 'api/labs',
        labById: 'api/labs/{labId}',
        labInstruments: 'api/labInstruments',
        postUserLabInstrument: 'api/userlabinstruments/{labId}/{labInstrumentId}',
        labInstrumentsWithLabId: 'api/labInstruments/{labId}',
        openedlabInstruments: 'api/labInstruments/{labId}',
        allLabInstruments: 'api/labInstruments/{labId}/allInstruments',
        allLabInstrumentLabTests: 'api/labTests/{labId}/{labInstrumentId}/allTests',
        closedLabTests: 'api/labTests/{labId}/{labInstrumentId}/closed',
        closedStudyTests: 'api/studytest/{labId}/{labInstrumentId}/closed',
        openCloseLabInstruments: 'api/labInstruments/{labId}/openClose',
        openCloseLabTests: 'api/labTests/{labId}/openClose',
        labTests: 'api/labTests',
        labTestsWithLabId: 'api/labTests/{labId}',
        defaultStudyId: 'api/labs/{labId}/defaultStudyId',
        updateLicense: 'api/labs/{labId}/License/Update',
        getAssignedUsers: 'api/userlabs/users/{labId}',
        getUsersByLabInstrumentId: 'api/userlabinstruments/users/{labInstrumentId}',
        getLabInstrumentsByLabIdAndUserId: 'api/userlabinstruments/labinstruments/{labId}/{userId}',
        unAssignLabInstrumentByUser: 'api/userlabinstruments/{labId}/{labInstrumentId}/delete',
        unAssignLabByUser: 'api/userlabs/{labId}/delete',
        getUser: 'api/user/userEmail/{email}',
        postUserLab: 'api/userlabs/{labId}',
        postOktaUserLab: 'api/user/addLabUser/{labId}/{isNewOktaUser}',
        postOktaUserLabInstrument: 'api/user/addLabInstrumentUser/{labId}/{labInstrumentId}/{isNewOktaUser}'

    },
    project: {
        projects: 'api/projects',
        projectInstruments: 'api/projectInstruments',
        projectTests: 'api/projectTests'
    },
    setupLab: {
        addLab: 'api/setuplab/addLab',
        instruments: 'api/setuplab/{labId}/instruments',
        analytes: 'api/setuplab/{labId}/analytes',
        matrices: 'api/setuplab/{labId}/matrices',
        methods: 'api/setuplab/{labId}/methods',
        reagents: 'api/setuplab/{labId}/reagents',
        units: 'api/setuplab/{labId}/units',
        importLabSetup: 'api/setuplab/import',
        importLevelDependentData: 'api/levelDependentData/import/{labId}/{studyId}',
        importData: 'api/setuplab/import-data/{labNumber}/{labId}/{studyId}?importOnlyUnityData={importOnlyUnityData}',
        importInstrumentTestsAndData: 'api/setuplab/import-instruments/{labNumber}/{labId}/{studyId}?importOnlyUnityData={importOnlyUnityData}',
        importDataStatus: 'api/setuplab/import-data/{labId}/status',
        cancelImportDataStatus: 'api/setuplab/import-data/{labId}/request/{requestId}/cancel'
    },
    qcPlanTestData: {
        testData: 'api/qcPlan2/{labId}/{studyId}/testData',
        saveStudyTestData: 'api/studytest/saveStudyTestData',
        saveStudyTestDataV2: 'api/studytest/v2/{labId}/saveStudyTestData',
        saveDependentData: 'api/levelDependentData/update/{labId}/{studyId}',
        allLabTestData: 'api/qcPlan2/allLabTestData'
    },
    qcPlanResult: {
        approvedQcPlan: 'api/qcPlan2/{labId}/{studyId}/qcPlanResult/approved',
        approvedQcPlanDetailByAnalyte: 'api/qcPlan2/{labId}/{studyId}/{studyTestDataId}/qcPlanDetailByAnalyte/approved',
        approvedQcPlanDetailByInstrument: 'api/qcPlan2/{labId}/{studyId}/{studyTestDataId}/qcPlanDetailByInstrument/approved',
        calculatedQcPlanDetailByAnalyte: 'api/qcPlan2/{labId}/{studyId}/{studyTestDataId}/qcPlanDetailByAnalyte/calculated',
        calculatedQcPlanDetailByInstrument: 'api/qcPlan2/{labId}/{studyId}/{studyTestDataId}/qcPlanDetailByInstrument/calculated',
        archiveQcPlan: 'api/reports/archives/{labId}/archiveQcPlan',
        archivedQcPlan: 'api/reports/archives/{labId}',
        archivedQcPlanDetail: 'api/reports/archives/{labId}/get/{archiveId}',
        deleteArchivedQcPlan: 'api/reports/archives/{labId}/delete'
    },
    tea: {
        teaConfigs: 'api/tea?refreshCache={refreshCache}',
        studyTestTeaConfigs: 'api/tea/study/{labId}/{studyId}/studyTestTeaConfigs?refreshCache={refreshCache}'
    },
    qcRule: {
        qcRules: 'api/qcrules'
    },
    severityOfHarm: {
        severityOfHarms: 'api/severityofharms'
    },
    dataRange: {
        dateRange: 'api/datarange/daterange',
        groupType: 'api/datarange/grouptype'
    },
    allowable: {
        labAllowables: 'api/allowables/{labId}',
        saveSelectedAllowables: 'api/allowables/{labId}'
    },
    referenceMean: {
        selectedReferenceMean: 'api/referenceMean/{labId}',
        saveSelectedReferenceMean: 'api/referenceMean/{labId}'
    },
    recommendations: {
        recommendationCount: 'api/recommendation2/lab/{labId}/count',
        unapprovedRecommendations: 'api/recommendation2/{labId}/unapproved',
        studyTestRecommendations: 'api/recommendation2/studyTestData/{studyTestDataId}/recommendations',

        approveTopRecommendation: 'api/approval/lab/{labId}/StudyTests/ApproveTopRecommendation',
        approveUserSelect: 'api/approval/lab/{labId}/StudyTests/ApproveUserSelect',
        declineRecommendation: 'api/approval/lab/{labId}/StudyTests/Decline',
        reImportSelected: 'api/levelDependentData/import/{labId}/{studyId}/selected'
    },

    calculation: {
        calculateRecommendations: 'api/calculation/{labId}/calculate',
        calculateAsync: 'api/calculation/{labId}/calculate-async',
        reCalculate: 'api/calculation/{labId}/re-calculate?labInstrumentId={labInstrumentId}',

        analyteCalculator: 'api/calculation/{labId}/analyte-calculator/{studyTestId}',
        analyteGraphics: 'api/calculation/{labId}/analyte-graphics/{studyTestDataId}',
        calculableAnalytes: 'api/calculation/{labId}/calculable-analytes?labInstrumentId={labInstrumentId}',
        calculationProgress: 'api/calculation/{labId}/calculation-progress',

        reImportSelected: 'api/levelDependentData/import/{labId}/{studyId}/selected'
    },

    qcPlanArchives: {
        getQcPlanArchives: 'api/reports/archives/{labId}',
        getArchive: 'api/reports/archives/{archiveId}/get',
        deleteQcPlanArchives: 'api/reports/archives/delete/{labId}',
        archiveQcPlan: 'api/reports/{labId}/archiveQcPlan'
    }
};



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/config/constants/mc-api-methods.const.ts